import {
  ListAgenticLogicDatasetsRequestQueryParamsType,
  ListAgenticLogicDatasetsResponseBodyType,
} from "@intelligems/ig-types/functions/agentic-logic/datasets/list";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const listAgenticLogicDatasets = async (
  queryParams: ListAgenticLogicDatasetsRequestQueryParamsType
) => {
  const resp = await api.get<ListAgenticLogicDatasetsResponseBodyType>(
    `/v2/agentic-logic/datasets`,
    { params: queryParams }
  );
  return resp.data;
};

/**
 * Lists the org's dataset summaries. Beyond the datasets tab this is load
 * bearing for an admin's editor: the Monaco types module is built from the
 * org's real dataset keys, and without them `sdk.getDataset()` types as
 * `never`. The route is Intelligems-staff only, so a caller that may be a
 * merchant passes `enabled: false` for them (see `useAgenticLogicDataSurface`).
 */
export const useAgenticLogicDatasets = (
  queryParams: ListAgenticLogicDatasetsRequestQueryParamsType = {},
  { enabled = true }: { enabled?: boolean } = {}
) => {
  return useQuery<ListAgenticLogicDatasetsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.datasets(queryParams.namespace),
    queryFn: async () => listAgenticLogicDatasets(queryParams),
    enabled,
  });
};
